import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import translate from "../../utilities/translator";
import { scrollToResults } from "../../utilities/helpers";
import { pushEvent } from "../../utilities/analytics";
import { SORT_BY_EVENT } from "../../constants/analyticEvents";


export default function MobileSort({ handleCheckbox, sort }) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();
  const activeSort = sort.filter(({ active }) => active)[0];

  useOnClickOutside(ref, () => isOpen && setIsOpen(false));

  const handleSortClick = index => () => {
    setIsOpen(false);
    handleCheckbox(index);
    pushEvent(SORT_BY_EVENT, sort.map((item, i) => ({
      ...item,
      active: index === i,
    })).find(({ active }) => active));
    scrollToResults();
  }

  return (
    <div className="sort" ref={ref}>
      <div className="sort__wrap" role="button" tabIndex={0}>
        <span>{translate("holidayFinder.secondaryFilter.Sort_by")} </span>
      </div>
      <div className={"sort__select"} onClick={() => setIsOpen(true)}>
      {translate(`holidayFinder.secondaryFilter.sort_${activeSort.label}`)}
        <i className="ri-arrow-down-s-line chevron" />
      </div>
      {isOpen && (
        <div className="sort__body">
          {sort.map(({ label, active }, i) => (
            <button
              className={active ? "active" : ""}
              type="button"
              onClick={handleSortClick(i)}
              key={label}
            >
              {translate(`holidayFinder.secondaryFilter.sort_${label}`)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

MobileSort.propTypes = {
  sort: PropTypes.array.isRequired,
  children: PropTypes.node,
};
